// src/components/watch/Filters.js
import React, { useState } from "react";
import PropTypes from "prop-types";
import "./Filters.css";

const Filters = ({ onFilter }) => {
  const [filters, setFilters] = useState({
    status: "all",
    minPool: "",
    timeFrame: "all",
  });

  const handleFilterChange = (field, value) => {
    const newFilters = {
      ...filters,
      [field]: value,
    };
    setFilters(newFilters);
    onFilter(newFilters);
  };

  return (
    <div className="filters-container">
      <div className="filter-group">
        <select
          className="filter-select"
          value={filters.status}
          onChange={(e) => handleFilterChange("status", e.target.value)}
        >
          <option value="all">All Status</option>
          <option value="active">Active</option>
          <option value="completed">Completed</option>
        </select>
      </div>

      <div className="filter-group">
        <input
          type="number"
          placeholder="Min Pool Size"
          className="filter-input"
          value={filters.minPool}
          onChange={(e) => handleFilterChange("minPool", e.target.value)}
        />
      </div>

      <div className="filter-group">
        <select
          className="filter-select"
          value={filters.timeFrame}
          onChange={(e) => handleFilterChange("timeFrame", e.target.value)}
        >
          <option value="all">All Time</option>
          <option value="today">Today</option>
          <option value="thisWeek">This Week</option>
        </select>
      </div>
    </div>
  );
};

Filters.propTypes = {
  onFilter: PropTypes.func.isRequired,
};

export default Filters;
